import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import User from 'records/User';
import withCoachingPlanWizard from 'components/coaching/wizard/withCoachingPlanWizard';
import './UpcomingAgendaEmpty.styl';

/**
 * Rendered in place of the three-column summary when there are absolutely no upcoming reviews.
 */
class UpcomingAgendaEmpty extends React.PureComponent {
  render() {
    const {coach, sessionUser, otherUserView, onCreatePlan} = this.props;
    return (
      <div className="upcoming-agenda-empty">
        <h3>Set Up Coaching Plans</h3>
        <div className="content">
          <p>
            {otherUserView ? `${coach.firstName} doesn't` : `You dont`} have any upcoming coaching
            meetings. Coaching plans can provide an effective way to methodically improve your reps'
            skills.
          </p>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={() =>
              onCreatePlan({
                coach: otherUserView ? sessionUser : coach,
              })
            }>
            Create A Coaching Plan
          </Button>
        </div>
      </div>
    );
  }
}

UpcomingAgendaEmpty.propTypes = {
  coach: PropTypes.instanceOf(User),
  otherUserView: PropTypes.bool,
};

export default withCoachingPlanWizard(UpcomingAgendaEmpty);
